(($) => {
  $(() => {
    const $links = $('a');

    if ($links.length) {
      $links.each((index, element) => {
        const $link = $(element);
        const linkHostname = $link.get(0).hostname;

        if (!$link.closest('#main, .sharing-links').length) return;

        if ($link.closest('.sharing-links, .resource').length) return;

        if ($link.has('.link-icon').length) return;

        if (!linkHostname.length || linkHostname === window.location.hostname) return;

        $link
          .attr({
            target: '_blank',
            rel: 'noopener noreferrer',
          })
          .append(
            '<span class="link-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><path d="M8.75,0a.875.875,0,0,0,0,1.75h2.261l-5.5,5.507A.876.876,0,0,0,6.746,8.5l5.5-5.507V5.25a.875.875,0,0,0,1.75,0V.875A.874.874,0,0,0,13.125,0ZM2.188.875A2.187,2.187,0,0,0,0,3.063v8.75A2.187,2.187,0,0,0,2.188,14h8.75a2.187,2.187,0,0,0,2.188-2.187V8.75a.875.875,0,0,0-1.75,0v3.063a.439.439,0,0,1-.437.438H2.188a.439.439,0,0,1-.437-.437V3.063a.439.439,0,0,1,.438-.437H5.25a.875.875,0,0,0,0-1.75Z" fill="currentColor"/></svg></span>'
          );
      });
    }
  });
})(jQuery);
